import React from 'react';
import '../App.css';
import Header from '../components/Header';
import Menu from '../components/Menu';
import Footer from '../components/Footer';
import AOS from "aos";
import "aos/dist/aos.css";
import WelcomeSmall from '../components/WelcomeSmall';
import Thesis from '../components/Thesis';

function teses() {
  
    AOS.init();
  

  return (
    <div className="App">  
      <Header />
      <Menu />
      <WelcomeSmall />
      <Thesis />
      <Footer/>
    </div>
  );
}

export default teses;
